import { xconsole } from '../utilities/utilities';

/**
 * Commonly used help links
 * Exporting for use in tests
 *
 * The Illuminate docs are still hosted on help.anthology.com; help.blackboard.com
 * only redirects to a generic product page. Paths follow the September 2026
 * restructure that dropped "anthology-" from them (AB#697834).
 */
export const helpLinks: Record<string, string> = {
    // Previously: https://help.blackboard.com/Anthology_Illuminate
    main: 'https://help.anthology.com/illuminate/?lang=en',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Get_Anthology_Illuminate
    getReportingHelp:
        'https://help.anthology.com/illuminate/en/get-started/request-access-to-illuminate.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Reporting
    reporting:
        'https://help.anthology.com/illuminate/en/illuminate-reporting.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Reporting/Learning
    learningReportingArea:
        'https://help.anthology.com/illuminate/en/illuminate-reporting/learning-reports.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Reporting/Teaching
    teachingReportingArea:
        'https://help.anthology.com/illuminate/en/illuminate-reporting/teaching-reports.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Reporting/Leading
    leadingReportingArea:
        'https://help.anthology.com/illuminate/en/illuminate-reporting/leading-reports.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Developer
    developer:
        'https://help.anthology.com/illuminate/en/illuminate-developer.html',
    // Previously: https://help.blackboard.com/Learn/Administrator/SaaS/Integrations/Direct_Data_Access
    directDataAccess:
        'https://help.anthology.com/blackboard/administrator/en/integrations/direct-data-access.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Developer/Data_Dictionary
    dataDictionary:
        'https://help.anthology.com/illuminate/en/illuminate-developer/data-dictionary.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Developer/Settings
    settings:
        'https://help.anthology.com/illuminate/en/get-started/configure-illuminate.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Role_Based_Access
    roles: 'https://help.anthology.com/illuminate/en/get-started/configure-illuminate/license-management/assign-roles-to-users.html',
    addOrDeleteUsers:
        'https://help.anthology.com/illuminate/en/get-started/configure-illuminate/license-management/add-or-delete-users.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Privacy_and_Security
    privacyAndSecurity:
        'https://help.anthology.com/illuminate/en/get-started/data-privacy-information-for-illuminate.html',
    privacyCenter: 'https://www.blackboard.com/trust-center',
    termsOfUse: 'https://www.blackboard.com/trust-center/terms-of-use',
    privacyStatement:
        'https://www.blackboard.com/trust-center/privacy-statement',
    aboutUs: 'https://www.blackboard.com/company',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Release_Notes
    releaseNotes: 'https://help.anthology.com/illuminate/en/whats-new.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Reporting/Data_QandA
    dataQAndA:
        'https://help.anthology.com/illuminate/en/illuminate-reporting/data-q-a.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Reporting/Custom_Reports
    customReports:
        'https://help.anthology.com/illuminate/en/illuminate-reporting/custom-reports.html',
    contactSupport:
        'https://support.anthology.com/s/topic/0TOPU00000Ao1Xp4AJ/anthology-illuminate?language=en_US',
    aboutIlluminate: 'https://www.blackboard.com/solutions/illuminate',
    exploreEnhanced: 'https://www.blackboard.com/solutions/illuminate',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Institutional_Authentication/UAS
    uasMigration:
        'https://help.anthology.com/illuminate/en/get-started/set-up-authentication/migrate-to-institutional-authentication.html',
    // Previously: https://help.blackboard.com/Anthology_Illuminate/Reporting/AI_Transparency_Note
    aiTransparencyNote:
        'https://help.anthology.com/illuminate/en/illuminate-reporting/data-q-a/illuminate-data-q-a---ai-transparency.html',
    generativeAiTerms:
        'https://www.blackboard.com/agreements/generative-ai-terms',
};

export function useHelpLinks(): (key: string) => string {
    return (key: string) => {
        let helpLink = helpLinks[key];

        // If we can't find a matching link, fall back on main help link
        if (!helpLink) {
            xconsole.warn(`A help link for key "${key}" was not found.`);
            helpLink = helpLinks.main;
        }

        return helpLink;
    };
}
